import React from 'react';
import { EditEventPage } from '../components';

export function CreateEventRoute(): JSX.Element {
    return (
        <EditEventPage />
    );
}
